import { getDomainListPathWorkoutUtil } from '../../../model/utils/get-domain-list-paths'
import { cloneWorkoutExerciseDataUtil, WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise'
import { WORKOUT_SECTION_KEY } from '../../../../workout-section'
import getWorkoutExercisesWorkoutSectionUtil from '../../../../workout-section/model/utils/get-workout-exercises'
import getOriginalParentIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-original-parent-id'
import getParentIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-parent-id'
import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'
import getWorkoutSectionsWorkoutUtil from '../../../../../modules/workout/model/utils/get-workout-sections'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import createReduxAction from '../../../../redux/actions/create'
import updateReduxAction from '../../../../redux/actions/update'
import { REDUX_LOCAL_KEY } from '../../../../redux/constants/local-key'
import cloneReduxUtil from '../../../../redux/utils/clone'
import { getChangedKeyPathReduxUtil } from '../../../../redux/utils/get-foreign-key-reference-path'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import getUpdatedDataReduxUtil from '../../../../redux/utils/get-updated-data'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import addReferenceAction from '../../../../references/actions/add'
import WORKOUT_EXERCISES_PATH from '../../../../workout-exercise/redux/constants/path'
import WORKOUT_SECTIONS_PATH from '../../../../workout-section/redux/constants/path'
import getByIdWorkoutSectionSelector from '../../../../workout-section/redux/selectors/get-by-id'
import loadByIdWorkoutAction from '../load-by-id'
import WORKOUTS_ACTION from '../../constants/action'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import getCurrentWorkoutSelect from '../../selectors/get-current'
import { createISOStrDateUtil, getObjectUtil, logUtil, omitObjectUtil } from 'packages/src'
import { WORKOUT_KEY } from '../../../model/constants/key'
import hasLoadedAssociationsReduxUtil from '../../../../redux/utils/has-loaded-associations'

export default function cloneWorkoutAction (params) {
  return async (dispatch, getState) => {
    logUtil('cloneWorkoutAction')
      .debug('[start] params: ', params)
    let {
      domainListPath,
      workout,
      id,
      data = {},
      keysToOmit = []
    } = params

    let currentWorkout = (
      workout ||
      (
        id && getByIdWorkoutSelector(id)(getState())
      ) ||
      getCurrentWorkoutSelect(getState())
    )
    logUtil('cloneWorkoutAction')
      .debug('currentWorkout: ', getIdReduxUtil(currentWorkout))
    currentWorkout = getInstanceReduxUtil(getState(), currentWorkout)
    if (!currentWorkout) {
      logUtil('cloneWorkoutAction')
        .debug('[noop]')
      return
    }

    if (!hasLoadedAssociationsReduxUtil(currentWorkout)) {
      await dispatch(loadByIdWorkoutAction(getIdReduxUtil(currentWorkout)))
    }

    currentWorkout = getInstanceReduxUtil(getState(), currentWorkout)

    if (!domainListPath) {
      domainListPath = getDomainListPathWorkoutUtil(currentWorkout, getState())
    }
    const workoutSectionPointers = getWorkoutSectionsWorkoutUtil(currentWorkout)

    const workoutSectionsDomainMap = getObjectUtil(getState(), WORKOUT_SECTIONS_PATH.DATA)
    const workoutExercisesDomainMap = getObjectUtil(getState(),
      WORKOUT_EXERCISES_PATH.DATA
    )
    const newWorkoutSectionsData = []
    workoutSectionPointers.forEach(workoutSectionPointer => {
      const id = getIdReduxUtil(workoutSectionPointer)
      const workoutSection = workoutSectionsDomainMap[id]
      if (!workoutSection) {
        return
      }
      const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
        workoutSection)
      const newWorkoutExercisesData = workoutExercisePointers.map(
        workoutExercisePointer => {
          const id = getIdReduxUtil(workoutExercisePointer)
          const workoutExercise = workoutExercisesDomainMap[id]
          return cloneWorkoutExerciseDataUtil(workoutExercise)
        })
      const newWorkoutSectionData = getUpdatedDataReduxUtil(cloneReduxUtil({
        instance: workoutSection,
        updates: {
          [WORKOUT_SECTION_KEY.WORKOUT_EXERCISES]: newWorkoutExercisesData
        }
      }))
      newWorkoutSectionsData.push(newWorkoutSectionData)
    })
    const now = createISOStrDateUtil()
    const parentId = getIdReduxUtil(currentWorkout)
    const originalParentId = (
      getOriginalParentIdWorkoutUtil(currentWorkout) ||
      getParentIdWorkoutUtil(currentWorkout) ||
      getIdReduxUtil(currentWorkout)
    )

    let newData = omitObjectUtil({
      [WORKOUT_KEY.ORIGINAL_PARENT_ID]: originalParentId,
      [WORKOUT_KEY.PARENT_ID]: parentId,
      [WORKOUT_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(getState()),
      [WORKOUT_KEY.WORKOUT_SECTIONS]: newWorkoutSectionsData,
      [WORKOUT_KEY.CREATED_AT]: now,
      [WORKOUT_KEY.UPDATED_AT]: now,
      [WORKOUT_KEY.PLAN_ID]: getPlanIdWorkoutUtil(currentWorkout),
      [WORKOUT_KEY.AUTHOR_ID]: (
        getValueReduxUtil(currentWorkout, WORKOUT_KEY.AUTHOR_ID) ||
        getValueReduxUtil(currentWorkout, WORKOUT_KEY.PROFILE_ID)
      )
    }, keysToOmit)
    const newKeysToOmit = [
      ...keysToOmit,
      WORKOUT_KEY.STARTED_AT,
      WORKOUT_KEY.SHARE_KEY,
      WORKOUT_KEY.LOGGED_AT,
      WORKOUT_KEY.FEATURED_AT,
      WORKOUT_KEY.RECOMMENDED_AT,
      WORKOUT_KEY.WORKOUT_SECTIONS,
      WORKOUT_KEY.LOCAL_IS_REORDERING_WORKOUT_EXERCISES,
      WORKOUT_KEY.LOCAL_IS_REORDERING_WORKOUT_SECTIONS,
      REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
      REDUX_LOCAL_KEY.IS_DOWNLOADED
    ]

    newData = cloneReduxUtil({
      instance: currentWorkout,
      updates: {
        ...newData, ...data
      },
      keysToOmit: newKeysToOmit
    })

    const newWorkout = dispatch(createReduxAction({
      type: WORKOUTS_ACTION.CLONE,
      payload: {
        domainListPath,
        data: newData
      }
    }))

    // Update the workout sections and workout exercises foreign keys
    const newWorkoutSectionInstances = getWorkoutSectionsWorkoutUtil(newWorkout)
      .map(workoutSectionPointer => {
        return getByIdWorkoutSectionSelector(getIdReduxUtil(
          workoutSectionPointer))(getState())
      })
    const updates = []
    const paths = newWorkoutSectionInstances.map((instance) => {
      updates.push({
        [WORKOUT_SECTION_KEY.WORKOUT_ID]: getIdReduxUtil(newWorkout)
      })
      return getPathReduxUtil(instance)
    })
    newWorkoutSectionInstances.forEach(newWorkoutSection => {
      const newWorkoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
        newWorkoutSection)
      newWorkoutExercisePointers.forEach(newWorkoutExercisePointer => {
        paths.push(getPathReduxUtil(newWorkoutExercisePointer))
        updates.push({
          [WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID]: (
            getIdReduxUtil(newWorkoutSection)
          )
        })
      })
    })
    dispatch(updateReduxAction({
      type: WORKOUTS_ACTION.ADD_FOREIGN_KEYS,
      payload: {
        paths,
        updates
      }
    }))

    // Add a reference to the parentId so it gets updated once it gets saved
    const parentWorkout = getByIdWorkoutSelector(parentId)(getState())
    if (parentWorkout) {
      dispatch(addReferenceAction({
        instance: parentWorkout,
        referencePath: getChangedKeyPathReduxUtil(newWorkout,
          WORKOUT_KEY.PARENT_ID
        )
      }))
    }
    // Add a reference to the original `originalParentId` so it gets updated
    // once it gets saved
    const originalParentWorkout = (
      getByIdWorkoutSelector(originalParentId)(getState())
    )
    if (originalParentWorkout) {
      dispatch(addReferenceAction({
        instance: originalParentWorkout,
        referencePath: getChangedKeyPathReduxUtil(newWorkout,
          WORKOUT_KEY.ORIGINAL_PARENT_ID
        )
      }))
    }
    return getInstanceReduxUtil(getState(), newWorkout)
  }
}
